import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SVG from '../SvgComponent';
import { STATIC_ROOT } from '../../constants';
import { GOOGLE, GOOGLE_LINK, APPLE, APPLE_LINK } from '../../constants/mobile';

import './DownloadButton.scss';

const getStoreName = (type, i18n) => {
    switch (type) {
        case GOOGLE:
            return i18n.GOOGLE_BRAND;
        case APPLE:
            return i18n.APPLE_BRAND;
        default:
            return '';
    }
};

export class DownloadButton extends React.Component {
    render() {
        const { type, onClick, inverted, i18n } = this.props;
        const storeName = getStoreName(type, i18n);

        return (
            <a href={`${type === GOOGLE ? GOOGLE_LINK : APPLE_LINK}`} target="_blank">
                <button
                    className={`download-btn ${type}${inverted ? ' inverted' : ''}`}
                    onClick={onClick}>
                    <SVG src={`${STATIC_ROOT}/${type}-store.svg`} width="19" height="24" />
                    <div>
                        {i18n.DOWNLOAD_ON}
                        <br />
                        <span>{storeName}</span>
                    </div>
                </button>
            </a>
        );
    }
}

DownloadButton.propTypes = {
    i18n: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    i18n: state.i18n.feature.DOWNLOAD_BUTTON
});

export default connect(mapStateToProps)(DownloadButton);



// WEBPACK FOOTER //
// ./src/components/button/DownloadButton.js